import { EMAIL_REPORT_FILES_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(EMAIL_REPORT_FILES_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    return { ok: response.status === 200 };
  } catch (error) {
    return { ok: false };
  }
};
